import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import formDefault from "../../docs/formDefault.json";
import claimDeadlineAlertBody from "../../docs/html/claim_deadline_alert_body.html?raw";
import claimDeadlineAlertForm from "../../docs/html/claim_deadline_alert_form.html?raw";
import generalInstructionsBody from "../../docs/html/general_instructions_body.html?raw";
import contactInformationBody from "../../docs/html/contact_information_body.html?raw";

const htmlAssets = {
    "./html/claim_deadline_alert_body.html": claimDeadlineAlertBody,
    "./html/claim_deadline_alert_form.html": claimDeadlineAlertForm,
    "./html/general_instructions_body.html": generalInstructionsBody,
    "./html/contact_information_body.html": contactInformationBody,
};

export class customSubmitClaim extends SubmitClaim {
    async form() {
        try {
            // Resolve against document.baseURI (anchored by index.html's
            // <base href="/">) so the docs path is independent of the current
            // route's URL depth.
            const baseUrl = new URL(
                "../../docs/formDefault.json",
                document.baseURI
            ).href;
            const config = await SubmitClaim.resolveHtmlFields(formDefault, {
                baseUrl,
                assets: htmlAssets,
            });
            const form = config.claim_form[this.lang];
            this.init_claim(form);
        } catch (error) {
            const wrapped = new Error("Error resolving claim form", {
                cause: error,
            });
            this.errorHandler.log_exception(wrapped);
            this.errorHandler.display(wrapped);
        }
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}
